import axios from "axios";
import _ from "lodash";
import moment from "moment";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL, itemCount, APP_API_KEY, MAIN_URL } from "Constants";
import { SubmissionError } from "redux-form";
// import { openDashboardUserModal } from "DashboardUserAction";

export var TICKET_LIST = "TICKET_LIST";
export var ALL_TICKET_LIST = "ALL_TICKET_LIST";
export var SINGLE_CATEGORY_TICKET_LIST = "SINGLE_CATEGORY_TICKET_LIST";
export var ALL_COUPON_LIST = "ALL_COUPON_LIST";
export var COUPON_LIST = "COUPON_LIST";
export var EDIT_COUPON = "EDIT_COUPON";
export var EDIT_TICKET = "EDIT_TICKET";
export var SETTING_DATA = "SETTING_DATA";
export var ORDER_LIST = "ORDER_LIST";
export var STRIPE_ACCOUNT_DATA = "STRIPE_ACCOUNT_DATA";
export var TICKET_DASHBOARD_STATUS = "TICKET_DASHBOARD_STATUS";
export const TICKET_MODAL = "TICKET_MODAL";
export const ORDER_ALLOTMENT_DETAILS = "ORDER_ALLOTMENT_DETAILS";
export const TICKET_URL_MODAL = "TICKET_URL_MODAL";
export const TICKET_ORDER_URL_MODAL = "TICKET_ORDER_URL_MODAL";
export const ORDER_TICKET_MODAL = "ORDER_TICKET_MODAL";
export const DEFAULT_TERMS_MODAL = "DEFAULT_TERMS_MODAL";
export var STRIPE_CURRENCY = "STRIPE_CURRENCY";
export var WIZARD_STEP = "WIZARD_STEP";
export var SALES_REPORT_EXPORT_MODAL = "SALES_REPORT_EXPORT_MODAL";
export var SALES_ORDER_REFUND_MODAL = "SALES_ORDER_REFUND_MODAL";
export var PAYMENT_GATEWAY_INFO_MODAL = "PAYMENT_GATEWAY_INFO_MODAL";
export var TICKET_SEND_LIST = "TICKET_SEND_LIST";
export var CLIENT_CARD_INFO_MODAL = "CLIENT_CARD_INFO_MODAL";
export var TICKET_SESSION_MODAL = "TICKET_SESSION_MODAL";
export var TICKET_SORTBY_MODAL = "TICKET_SORTBY_MODAL";

export function ticketnameExist(session, ticketname, callback) {
  var filter = encodeURIComponent(
    `((eventid=${session.eventid})AND(ticketname=${ticketname}))`
  );
  var ticketurl = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?filter=${filter}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      ticketurl,
      session,
      dispatch,
      (response) => {
        if (response.resource && response.resource.length > 0) {
          callback({ success: 0 });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchAllTickets(session, callback) {
  let related = "orderdetails_by_ticketid,event_forms_by_formid";
  let filter = encodeURIComponent(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?include_count=true&related=${related}&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        _.map(response.resource, (ticket, index) => {
          let activeTicets = _.filter(
            ticket.orderdetails_by_ticketid,
            function (obj) {
              return obj.status == "active";
            }
          );

          let soldTicketsArray = _.sumBy(activeTicets, function (sold) {
            return sold.quantity;
          });

          response.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: ALL_TICKET_LIST,
          payload: { resource: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchTickets(session, callback) {
  let related = "orderdetails_by_ticketid,event_forms_by_formid";
  let filter = encodeURIComponent(
    `(eventid=${session.eventid})AND(status!='internal')`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?include_count=true&related=${related}&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        _.map(response.resource, (ticket, index) => {
          let activeTicets = _.filter(
            ticket.orderdetails_by_ticketid,
            function (obj) {
              return obj.status === "active";
            }
          );

          let soldTicketsArray = _.sumBy(activeTicets, function (sold) {
            return sold.quantity;
          });

          response.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: TICKET_LIST,
          payload: { resource: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchTicket(session, search = "", callback) {
  let searchQuery = `(ticketname CONTAINS ${search}) OR (tickecode CONTAINS ${search})`;
  let related = "orderdetails_by_ticketid,event_forms_by_formid";
  let filter = encodeURIComponent(
    `(eventid=${session.eventid})AND(status!='internal')AND(${searchQuery})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?include_count=true&related=${related}&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        _.map(response.resource, (ticket, index) => {
          let activeTicets = _.filter(
            ticket.orderdetails_by_ticketid,
            function (obj) {
              return obj.status === "active";
            }
          );

          let soldTicketsArray = _.sumBy(activeTicets, function (sold) {
            return sold.quantity;
          });

          response.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: TICKET_LIST,
          payload: { resource: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchSingleCategoryTickets(
  session,
  pageCount = 0,
  countPerPage = 0,
  categoryFilter,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?related=orderdetails_by_ticketid,event_forms_by_formid&include_count=true&filter=(${categoryFilter})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        _.map(data.resource, (ticket, index) => {
          let activeTicets1 = _.filter(
            ticket.orderdetails_by_ticketid,
            function (obj) {
              return obj.status == "active";
            }
          );

          let soldTicketsArray = _.sumBy(activeTicets1, function (sold) {
            return sold.quantity;
          });

          data.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: SINGLE_CATEGORY_TICKET_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function searchSingleCategoryTicket(
  session,
  searchQuery,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var itemCount = 20;
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?related=orderdetails_by_ticketid,event_forms_by_formid&include_count=true&filter=(${searchQuery})&order=createdon%20DESC${offSetQuery}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        _.map(data.resource, (ticket, index) => {
          let soldTicketsArray = _.sumBy(
            ticket.orderdetails_by_ticketid,
            function (sold) {
              return sold.quantity;
            }
          );

          data.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: SINGLE_CATEGORY_TICKET_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function openTicketUrl(showModal, ticketCode = "") {
  return {
    type: TICKET_URL_MODAL,
    payload: { showModal: showModal, ticketCode: ticketCode },
  };
}

export function addTicket(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;

  let eventid = session.eventid;
  let createdby = session.userid;
  let updatedby = createdby;
  //let status = 'enabled';
  let tickecode = "";
  values = { ...values, eventid, createdby, updatedby };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function editTicket(ticket) {
  return (dispatch) => {
    if (!_.isEmpty(ticket)) {
      if (ticket.salestartdate && ticket.saleenddate) {
        var ddststart = ticket.salestartdate.split(" ");
        ticket.startdate = ddststart[0];
        ticket.starttime = ddststart[1];
        var ddstend = ticket.saleenddate.split(" ");
        ticket.enddate = ddstend[0];
        ticket.endtime = ddstend[1];
      }
    }
    dispatch({ type: EDIT_TICKET, payload: ticket });
  };
}

export function ticketAssociatedWithSession(session, ticket, callback) {
  var filter = `((eventid=${session.eventid})AND(sessiontype='additional')AND(ticketassociated=${ticket.id}))`;
  var ticketurl = `${INSTANCE_URL}/api/v2/eventify/_table/session?filter=${filter}`;
  return (dispatch) => {
    getRequest(
      ticketurl,
      session,
      dispatch,
      (response) => {
        if (response.resource && response.resource.length > 0) {
          callback({ success: 0, result: response.resource });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {}
    );
  };
}

export function deleteTicket(session, ticket, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var postData = {
    eventid: session.eventid,
    ticketid: ticket.id,
    type: "deleteTicket",
  };
  return (dispatch) => {
    postRequest(
      url,
      postData,
      session,
      dispatch,
      (data) => {
        // old code if (data.response_delete == true && response_session_update == true) {
        if (data.response_delete == true) {
          callback({ success: 1, result: data });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateTicket(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;
  var json = {
    resource: {
      ...values,
      updatedby: session.userid,
      eventid: session.eventid,
    },
  };

  return (dispatch) => {
    var successCallback = (data) => {
      callback({ error: 0, data: data });
    };
    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };
    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function couponExist(session, couponcode, callback) {
  var filter = encodeURIComponent(
    `((eventid=${session.eventid})AND(couponcode=${couponcode}))`
  );
  var couponurl = `${INSTANCE_URL}/api/v2/eventify/_table/coupons?filter=${filter}&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      couponurl,
      session,
      dispatch,
      (response) => {
        if (response.resource && response.resource.length > 0) {
          callback({ success: 0 });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {}
    );
  };
}

export function fetchAllCoupons(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons?filter=(eventid=${session.eventid})&include_count=true&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: ALL_COUPON_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchCoupons(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}&`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons?${offSetQuery}include_count=true&filter=eventid=${session.eventid}&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COUPON_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchCoupon(
  session,
  search = "",
  pageCount = 0,
  countPerPage = 0
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}&`;
  let searchQuery = `(couponcode like %${search}%)`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons?${offSetQuery}include_count=true&filter=(${searchQuery}) AND (eventid=${session.eventid})&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: COUPON_LIST,
          payload: { resource: data.resource, count: data.meta.count },
        });
      },
      (error) => {}
    );
  };
}

export function addCoupon(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons`;

  let eventid = session.eventid;
  let createdby = session.userid;
  let updatedby = createdby;
  //let status = 'enabled';
  var ticketid = values["discountfor"] == "all" ? 0 : values["discountfor"];

  values = { ...values, ticketid, eventid, createdby, updatedby };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(fetchCoupons(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteCoupon(session, coupon, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons/${coupon.id}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(fetchCoupons(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function editCoupon(coupon) {
  return (dispatch) => {
    if (!_.isEmpty(coupon)) {
      var ddststart = coupon.discountstart.split(" ");
      coupon.startdate = ddststart[0];
      coupon.starttime = ddststart[1];
      var ddstend = coupon.discountend.split(" ");
      coupon.enddate = ddstend[0];
      coupon.endtime = ddstend[1];
      var ticketid = coupon.ticketid;
      coupon.discountfor = ticketid == 0 ? "all" : ticketid;
    }
    dispatch({ type: EDIT_COUPON, payload: coupon });
  };
}

export function updateCoupon(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/coupons`;
  var ticketid = values["discountfor"] == "all" ? 0 : values["discountfor"];
  var json = { resource: { ...values, ticketid, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchCoupons(session));
      callback({ error: 0, data: data });
    };
    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };
    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function fetchSettings(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?related=*&filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: SETTING_DATA, payload: data });
        callback({ success: 1, data: data });
      },
      (error) => {}
    );
  };
}

export function addSetting(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings`;

  let eventid = session.eventid;
  let createdby = session.userid;
  let updatedby = createdby;
  values = { ...values, eventid, createdby, updatedby };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(fetchSettings(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateSetting(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var json = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchSettings(session));
      callback({ success: 1, data: data });
    };
    var errorCallback = (error) => {
      callback({ success: 0, data: error });
    };
    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function fetchOrders(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND((paymentstatus='paid')||(paymentmethod='paylater'))`
  );
  // var filter = encodeURI(`(eventid=${session.eventid})`);

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/orders?filter=(${filter})&include_count=true&related=orderdetails_by_orderid,tickets_by_orderdetails&order=createdon%20DESC${offSetQuery}`;
  var urlTotal = `${INSTANCE_URL}/api/v2/eventify/_table/orders?filter=(${filter})&include_count=true&related=orderdetails_by_orderid,tickets_by_orderdetails&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        getRequest(
          urlTotal,
          session,
          dispatch,
          (response) => {
            // Logic added to handle reunded tickets

            let allOrderArr = [];
            let orderArr = [];
            _.map(data.resource, (obj) => {
              let orderdetails = obj.orderdetails_by_orderid;
              let orderticketdetails = obj.tickets_by_orderdetails;

              // Get all purchased active tickets
              let activeTickets = _.filter(orderdetails, (o) => {
                return o.status === "active";
              });

              // Get all refunded tickets
              let refundedTickets = _.filter(orderdetails, (o) => {
                return o.status == "refunded";
              });

              let orderTicketsArr = [];
              _.map(activeTickets, (o) => {
                let ticketId = o.ticketid;
                let ticketQty = o.quantity;
                let ticketPrice = o.price;
                let ticketDiscount = o.discount;
                let ticketTax = o.taxamount;

                // Check any refunded ticket is available
                let refundedTicketsMatch = _.filter(refundedTickets, (o) => {
                  return o.ticketid === ticketId;
                });

                let existingRefundedTicketsQty =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "quantity")
                    : 0; // already refunded tickets quantity
                let existingRefundedTicketsPrice =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "price")
                    : 0; // already refunded tickets price
                let existingRefundedTicketsDiscount =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "discount")
                    : 0; // already refunded tickets discount
                let existingRefundedTicketsTax =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "taxamount")
                    : 0; // already refunded tickets taxamount

                let leftQty = ticketQty - existingRefundedTicketsQty;
                let leftrice = ticketPrice - existingRefundedTicketsPrice;
                let leftDiscount =
                  ticketDiscount - existingRefundedTicketsDiscount;
                let leftTax = ticketTax - existingRefundedTicketsTax;

                o.quantity = leftQty;
                o.price = leftrice;
                o.discount = leftDiscount;
                o.taxamount = leftTax;

                // Get single sicket details
                let singleTicketMatch = _.filter(orderticketdetails, (o) => {
                  return o.id === ticketId;
                });

                orderTicketsArr.push(singleTicketMatch[0]);
              });

              obj.orderdetails_by_orderid = activeTickets;
              obj.tickets_by_orderdetails = orderTicketsArr;
              allOrderArr.push(obj);

              // Order exist in list data
              let match = _.filter(data.resource, (o) => {
                return o.id === obj.id;
              });
              if (match.length > 0) {
                orderArr.push(match[0]);
              }
            });

            dispatch({
              type: ORDER_LIST,
              payload: {
                resource: orderArr,
                count: data.meta.count,
                totalOrder: response.resource,
              },
            });
            callback({ success: 1 });
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  };
}

export function searchOrder(
  session,
  search = "",
  pageCount = 0,
  countPerPage = 0,
  startdate = "",
  enddate = "",
  sortby = "",
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  let searchQuery = `(email like %${search}%) OR (orderid like ${search}%)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})AND((paymentstatus='paid')||(paymentmethod='paylater'))`
  );
  // var filter = encodeURI(`(status='approve') AND (eventid=${session.eventid})`);

  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/orders?filter=(${filter} AND (${searchQuery}))&include_count=true&related=orderdetails_by_orderid&order=createdon%20DESC${offSetQuery}`;
  // return (dispatch)=>{
  //   getRequest(url, session, dispatch, (data) => {
  //     dispatch({type:ORDER_LIST, payload : {resource:data.resource,count: data.meta.count}});
  //     callback({success: 1});
  //   }, (error) => {

  //   });
  // };

  // Custom search
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  let payload = {
    type: "searchTicketOrderRef",
    eventid: session.eventid,
    search: search,
    offset: offset,
    perPage: itemCount,
    startdate:
      startdate != "" ? moment(startdate).format("YYYY-MM-DD HH:mm:ss") : "",
    enddate: enddate != "" ? moment(enddate).format("YYYY-MM-DD HH:mm:ss") : "",
    sortby: sortby == "all" || sortby == "" ? "" : sortby,
  };

  var urlTotal = `${INSTANCE_URL}/api/v2/eventify/_table/orders?filter=(${filter})&include_count=true&related=orderdetails_by_orderid,tickets_by_orderdetails&order=createdon%20DESC`;
  return (dispatch) => {
    postRequest(
      url,
      payload,
      session,
      dispatch,
      (data) => {
        getRequest(
          urlTotal,
          session,
          dispatch,
          (response) => {
            // Logic added to handle reunded tickets

            let allOrderArr = [];
            let orderArr = [];
            _.map(data.resource, (obj) => {
              let orderdetails = obj.orderdetails_by_orderid;
              let orderticketdetails = obj.tickets_by_orderdetails;

              // Get all purchased active tickets
              let activeTickets = _.filter(orderdetails, (o) => {
                return o.status === "active";
              });

              // Get all refunded tickets
              let refundedTickets = _.filter(orderdetails, (o) => {
                return o.status == "refunded";
              });

              let orderTicketsArr = [];
              _.map(activeTickets, (o) => {
                let ticketId = o.ticketid;
                let ticketQty = o.quantity;
                let ticketPrice = o.price;
                let ticketDiscount = o.discount;
                let ticketTax = o.taxamount;

                // Check any refunded ticket is available
                let refundedTicketsMatch = _.filter(refundedTickets, (o) => {
                  return o.ticketid === ticketId;
                });

                let existingRefundedTicketsQty =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "quantity")
                    : 0; // already refunded tickets quantity
                let existingRefundedTicketsPrice =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "price")
                    : 0; // already refunded tickets price
                let existingRefundedTicketsDiscount =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "discount")
                    : 0; // already refunded tickets discount
                let existingRefundedTicketsTax =
                  refundedTicketsMatch.length > 0
                    ? _.sumBy(refundedTicketsMatch, "taxamount")
                    : 0; // already refunded tickets taxamount

                let leftQty = ticketQty - existingRefundedTicketsQty;
                let leftrice = ticketPrice - existingRefundedTicketsPrice;
                let leftDiscount =
                  ticketDiscount - existingRefundedTicketsDiscount;
                let leftTax = ticketTax - existingRefundedTicketsTax;

                o.quantity = leftQty;
                o.price = leftrice;
                o.discount = leftDiscount;
                o.taxamount = leftTax;

                // Get single sicket details
                let singleTicketMatch = _.filter(orderticketdetails, (o) => {
                  return o.id === ticketId;
                });

                orderTicketsArr.push(singleTicketMatch[0]);
              });

              obj.orderdetails_by_orderid = activeTickets;
              obj.tickets_by_orderdetails = orderTicketsArr;
              allOrderArr.push(obj);

              // Order exist in list data
              let match = _.filter(data.resource, (o) => {
                return o.id === obj.id;
              });
              if (match.length > 0) {
                orderArr.push(match[0]);
              }
            });

            dispatch({
              type: ORDER_LIST,
              payload: {
                resource: orderArr,
                count: data.count,
                totalOrder: response.resource,
              },
            });
            callback({ success: 1 });
          },
          (error) => {
            callback({ success: 0, error: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function fetchStripeAccount(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/ticket_stripe?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: STRIPE_ACCOUNT_DATA, payload: data });
      },
      (error) => {}
    );
  };
}

export function updateStripeAccount(stripeaccountid, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/ticket_stripe`;
  let eventid = session.eventid;
  let values = { stripeaccountid, eventid };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(updateEventSettingWithStripe(session));
        dispatch(fetchStripeAccount(session));
        dispatch(checkTicketDaschoardStatus(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateEventSettingWithStripe(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var body = {
    resource: {
      paymentgatewaytype: "stripe",
      paymentgatewaysettingjson: null,
      stripecustomerid: null,
      stripecustomercardid: null,
    },
  };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteStripeAccount(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/stripeDeauthorize`;
  var body = { eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        dispatch(fetchStripeAccount(session));
        dispatch(checkTicketDaschoardStatus(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openTicketModal(showModal) {
  return { type: TICKET_MODAL, payload: showModal };
}

export function checkTicketDaschoardStatus(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=ticketDashboardStatus&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: TICKET_DASHBOARD_STATUS,
          payload: { data: response },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function updateTicketLiveStatus(session, value, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var body = { resource: { id: id, islive: value } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateFormid(session, value, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var body = { resource: { id: id, eventformid: value } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openOrderDetailsUrl(showModal, orderId = "") {
  return {
    type: TICKET_ORDER_URL_MODAL,
    payload: { showModal: showModal, orderId: orderId },
  };
}

export function openOrderTicketModel(showModal) {
  return { type: ORDER_TICKET_MODAL, payload: showModal };
}

export function openTermsModal(record) {
  return { type: DEFAULT_TERMS_MODAL, payload: record };
}

export function fetchStripeCurrency(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/stripe_currency`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: STRIPE_CURRENCY, payload: data.resource });
      },
      (error) => {}
    );
  };
}

export function fetchWizardStep(step) {
  return { type: WIZARD_STEP, payload: step };
}

export function updateFormTickets(
  session,
  values,
  formid,
  eventformid,
  callback
) {
  var selectedTicketsStr = values;

  // Updated tickets with null where formid
  var filter = `((eventid=${session.eventid}) AND (formid=${formid}))`;
  var urlClear = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?filter=${filter}`;
  var bodyNull = { resource: [{ formid: null }] };

  // Update tickets with new associated formid
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;
  var update = [];
  _.map(selectedTicketsStr, (item) => {
    update.push({
      id: item.id,
      eventid: session.eventid,
      formid: parseInt(formid),
    });
  });
  var body = { resource: update };

  // Update tickets having null formid with default fromid
  var filter1 = `((eventid=${session.eventid}) AND (formid IS NULL))`;
  var urlnullUpdate = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?filter=${filter1}`;
  var bodyEventForm = { resource: [{ formid: eventformid }] };

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchTickets(session));
      var returnData = { error: 0, data: data };
      callback(returnData);
    };

    var errorCallback = (error) => {
      var returnData = { error: 1, data: error };
      callback(returnData);
    };

    patchRequest(
      urlClear,
      bodyNull,
      session,
      dispatch,
      (data) => {
        // Chech if any ticket is associated or not with this formid
        if (selectedTicketsStr.length > 0) {
          patchRequest(
            url,
            body,
            session,
            dispatch,
            (response) => {
              patchRequest(
                urlnullUpdate,
                bodyEventForm,
                session,
                dispatch,
                successCallback,
                errorCallback
              );
            },
            (error) => {
              callback({ error: 1, data: error });
            }
          );
        } else {
          patchRequest(
            urlnullUpdate,
            bodyEventForm,
            session,
            dispatch,
            successCallback,
            errorCallback
          );
        }
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function openSalesReportExportModal(showModal) {
  return { type: SALES_REPORT_EXPORT_MODAL, payload: showModal };
}

export function fetchDownloadSalesReport(
  session,
  startdate = "",
  enddate = "",
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/downloadsalesreport`;
  var body = {
    eventid: session.eventid,
    startdate:
      startdate != "" ? moment(startdate).format("YYYY-MM-DD HH:mm:ss") : "",
    enddate: enddate != "" ? moment(enddate).format("YYYY-MM-DD HH:mm:ss") : "",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function redundModalCall(obj) {
  return { type: SALES_ORDER_REFUND_MODAL, payload: obj };
}

export function refundOrder(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/salesorderrefund`;
  var body = { ...values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        if (data.success == 1) {
          callback({ success: 1, data: data });
        } else {
          callback({ success: 2, message: data.message });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openPaymentGatewayInfoModal(obj) {
  return { type: PAYMENT_GATEWAY_INFO_MODAL, payload: obj };
}

export function openClientCardInfoModal(obj) {
  return { type: CLIENT_CARD_INFO_MODAL, payload: obj };
}

export function createCustomerStripeToken(session, values, callback) {
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/json",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/stripeapi/api.php`;
  var body = { ...values, action: "add_card" };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.code == 200) {
          callback({ success: 1, custid: data.data });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function addStripeToken(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var json = { resource: { ...values } };

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchSettings(session));
      dispatch(checkTicketDaschoardStatus(session));
      callback({ success: 1, data: data });
    };
    var errorCallback = (error) => {
      callback({ success: 0, data: error });
    };
    patchRequest(url, json, session, dispatch, successCallback, errorCallback);
  };
}

export function updateCustomerStripeToken(session, values, callback) {
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/json",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/stripeapi/api.php`;
  var body = { ...values, action: "update_card" };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.code == 200) {
          callback({ success: 1, cardid: data.data });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function deleteCardFromStripe(session, values, callback) {
  var config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Access-Control-Allow-Headers": "Origin, Content-Type",
      "content-Type": "application/json",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };
  var url = `${MAIN_URL}/stripeapi/api.php`;
  var body = { ...values };

  var response = axios.post(url, body, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.code == 200) {
          callback({ success: 1 });
        } else {
          callback({ success: 0 });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function deletePayfastInfo(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  var body = { resource: { ...values } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchSettings(session));
        dispatch(checkTicketDaschoardStatus(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function ticketsForSend(session, filter, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?related=orderdetails_by_ticketid,event_forms_by_formid&include_count=true&filter=${filter}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        _.map(response.resource, (ticket, index) => {
          let activeTicets = _.filter(
            ticket.orderdetails_by_ticketid,
            function (obj) {
              return obj.status == "active";
            }
          );

          let soldTicketsArray = _.sumBy(activeTicets, function (sold) {
            return sold.quantity;
          });

          response.resource[index].totalsoldtickets = soldTicketsArray;
        });

        dispatch({
          type: TICKET_SEND_LIST,
          payload: { resource: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function updateOrderPaymentStatus(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  var body = { ...values };
  // console.log("body :- ", body);

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        // console.log("data :- ", data);
        if (data.success === 1) {
          callback({ success: 1, data: data.resource });
          dispatch(fetchOrders(session));
        } else {
          callback({ success: 2, data: data });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendOrderEmailToBuyer(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/orderConfirmationmail`;
  var body = { ...values };
  // console.log("body :- ", body);

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        // console.log("data :- ", data);
        if (data.success === 1) {
          callback({ success: 1, data: data });
        } else {
          callback({ success: 2, data: data });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openSessionModal(obj) {
  return { type: TICKET_SESSION_MODAL, payload: obj };
}

export const updateEventSettingsTrackingPixel = (
  session,
  settingsId,
  value,
  callback
) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(id=${settingsId}))`
  );
  let patchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=${fetchFilter}`;

  let patchBody = {
    resource: { trackingpixel: JSON.stringify(value) },
  };

  return (dispatch) => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      (res) => {
        dispatch(
          fetchSettings(session, (res) => {
            dispatch({ type: SETTING_DATA, payload: res });
            callback({ success: 1, data: res.resource[0] });
          })
        );
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export function openTicketSortbyModal(showModal) {
  return {
    type: TICKET_SORTBY_MODAL,
    payload: { showModal: showModal },
  };
}

export function updateSortedTicket(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets`;
  var data = _.map(values, (obj) => ({
    id: obj.id,
    orderby: obj.orderby,
    eventid: session.eventid,
  }));
  var body = { resource: data };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
